import { createFileRoute } from '@tanstack/react-router'

import { RedirectFromCatchAll } from '~/components/redirect-from-catch-all'

export const Route = createFileRoute('/$')({
  component: RedirectFromCatchAll,
})
